"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** Encapsulates artifacts from generating a random Wallet via a seed. */
class SeedWalletGenerationResult {
    /**
     * Creates a new SeedWalletGenerationResult.
     *
     * @param seed - The base58check encoded seed which generates the associated wallet.
     * @param wallet - The wallet generated from the associated seed.
     */
    constructor(seed, wallet) {
        this.seed = seed;
        this.wallet = wallet;
    }
}
exports.default = SeedWalletGenerationResult;
//# sourceMappingURL=seed-wallet-generation-result.js.map